/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgCapabilitiesFleetManagement } from './tenantOrgCapabilitiesFleetManagement';
import { TenantOrgCapabilitiesAccess } from './tenantOrgCapabilitiesAccess';
import { TenantOrgCapabilitiesDeployments } from './tenantOrgCapabilitiesDeployments';
import { TenantOrgCapabilitiesRansomwareRecovery } from './tenantOrgCapabilitiesRansomwareRecovery';
import { TenantOrgCapabilitiesCommerce } from './tenantOrgCapabilitiesCommerce';
import { TenantOrgCapabilitiesResource } from './tenantOrgCapabilitiesResource';


export interface TenantOrgCapabilitiesVcdr { 
    deployments?: TenantOrgCapabilitiesDeployments;
    access?: TenantOrgCapabilitiesAccess;
    resource?: TenantOrgCapabilitiesResource;
    commerce?: TenantOrgCapabilitiesCommerce;
    fleet_management?: TenantOrgCapabilitiesFleetManagement;
    ransomware_recovery?: TenantOrgCapabilitiesRansomwareRecovery;
}

